import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {Button} from "primereact/button";
import {useState} from "react";
import {atomDark} from "react-syntax-highlighter/dist/esm/styles/prism";

function CodeExample({code, language}: { code: string, language: string }) {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div style={{position: "relative"}}>
            <SyntaxHighlighter
                language={language}
                style={atomDark}
                customStyle={{margin: 0, padding: "1rem"}}
            >
                {code}
            </SyntaxHighlighter>
            <Button
                icon={copied ? "pi pi-check" : "pi pi-copy"}
                className="p-button-sm p-button-text"
                style={{
                    position: "absolute",
                    top: "0.5rem",
                    right: "0.5rem",
                }}
                onClick={copyToClipboard}
                aria-label="Copy code"
            />
        </div>
    );
}

export default CodeExample;